// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__QCfvu","search":"Settings_search__2kxyI","filter":"Settings_filter__1Bl3M"};